import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e88a31a8&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e88a31a8', component.options)
    } else {
      api.reload('e88a31a8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e88a31a8&", function () {
      api.rerender('e88a31a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Peajes/Reportes/index.vue"
export default component.exports